import React from 'react'

function ConteneurActif({nbConteneur, nbConteneurFalse}) {
  return (
    
    <div className="col-md-6 col-xl-3 mb-4">
        <div className="card shadow border-start-primary py-2">
            <div className="card-body">
                <div className="row align-items-center no-gutters">
                    <div className="col me-2">
                        <div className="text-uppercase text-primary fw-bold text-xs mb-1"><span>Conteneurs actifs</span></div>
                        <div className="text-dark fw-bold h5 mb-0"><span>{nbConteneur-nbConteneurFalse}</span></div>
                    </div>
                    <div className="col-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" className="fa-2x text-gray-300">
                            <path d="M19 11H5M19 11C20.1046 11 21 11.8954 21 13V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V13C3 11.8954 3.89543 11 5 11M19 11V9C19 7.89543 18.1046 7 17 7M5 11V9C5 7.89543 5.89543 7 7 7M7 7V5C7 3.89543 7.89543 3 9 3H15C16.1046 3 17 3.89543 17 5V7M7 7H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg></div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ConteneurActif